export default __webpack_public_path__ + "icon_notebook.f5ad49e55a1804c34e68a9418595a8f9.svg";